import { render } from "./ChatbotFab.vue?vue&type=template&id=25f6628f&scoped=true"
import script from "./ChatbotFab.vue?vue&type=script&lang=js"
export * from "./ChatbotFab.vue?vue&type=script&lang=js"

import "./ChatbotFab.vue?vue&type=style&index=0&id=25f6628f&scoped=true&lang=css"
import "./ChatbotFab.vue?vue&type=style&index=1&id=25f6628f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f6628f"]])

export default __exports__